import { DataTable } from '@/components/ui/data-table/DataTable';
import { columns } from './columns';

import dayjs from 'dayjs';
import { useGetHourlyUsageLogs } from '@/service/llm/usage-logs/hook';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';

type Props = {
  month: string;
};
const ActivityTable = ({ month }: Props) => {
  const { workspaceId } = useParamWorkspaceId();
  const { data } = useGetHourlyUsageLogs({
    startDate: dayjs(month).startOf('month').unix(),
    endDate: dayjs(month).endOf('month').unix(),
    workspaceId: workspaceId,
  });

  return (
    <div className="">
      <DataTable columns={columns} data={data || []} />
    </div>
  );
};

export default ActivityTable;
